import { apiGet, apiPost } from '../client';
import {
  BusinessLocationListResponseSchema,
  BusinessLocationSwitchResponseSchema,
  type BusinessLocation,
} from '../schemas';

/** Every location of the caller's organization, owner-only. */
export function listLocations(): Promise<{ data: BusinessLocation[] }> {
  return apiGet('/v1/business/locations', BusinessLocationListResponseSchema);
}

/** Moves the caller's own session onto a different location of the same organization. */
export function switchLocation(businessId: string): Promise<{ businessId: string }> {
  return apiPost('/v1/business/session/location', BusinessLocationSwitchResponseSchema, { businessId });
}
